import React from 'react'
import PropTypes from 'prop-types'
import { StatisticsItems } from '../../organism'

const Statistics = ({ classes }) => {

  return (
    <div className={classes.root}>
    <StatisticsItems />
  </div>
  )
}

Statistics.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Statistics
